import React from "react";

import { useAuth } from "contexts/Auth";
import { AuthenticatedRoutes, UnauthenticatedRoutes } from "routes";

export const AuthGate = () => {
  const {
    state: { isLoggedIn },
  } = useAuth();
  return <>{isLoggedIn ? <AuthenticatedRoutes /> : <UnauthenticatedRoutes />}</>;
};

export default AuthGate;
